import React, {useContext} from 'react';
import Stack from '@mui/material/Stack';
import Dropzone from '../Chat/Dropzone.js';
import {matchesAnyRegex} from "../App/utils.js";
import {AlertContext} from "../App/App.js";
import {uploadFileAPI} from "../API/KB/Files.js";
import {MESSAGE} from "../App/constants";

const types = [/image/i];
export const ImageEditor = ({ style, setBlockingLoading, onSuccess = () => {}, onClick = () => {} }) => {
    const {setSystemAlert} = useContext(AlertContext);

    const onFileUpload = async (event) => {
        const selectedFile = event instanceof File ? event : event.target.files[0];

        if (!selectedFile?.type) return;

        if (!matchesAnyRegex(selectedFile.type, types)) {
            setSystemAlert({msg: 'Invalid file type', type: 'error', duration: 3000})
            return;
        }

        if (!selectedFile) {
            setSystemAlert({msg: 'Please select file to upload', type: 'error', duration: 3000})
            return;
        }

        try {
            setBlockingLoading(1);
            const response = await uploadFileAPI(selectedFile, 'files', (percentage) => {
                setBlockingLoading(percentage);
            });

            const inputImage = response?.request?.responseURL?.split('?')?.[0];

            setBlockingLoading(false);

            if (inputImage) onSuccess(JSON.stringify({ type: MESSAGE.IMAGE_EDITOR, images: [{url: inputImage, selected: true}] }))

        } catch (e) {
            setBlockingLoading(false)
            alert('Error during upload');
            console.error(e);
        }

        if(event?.target?.value) event.target.value = null;
    }

    return (
        <Stack alignItems="center" spacing={2} style={style} onClick={onClick}>
            <Dropzone onFileUpload={onFileUpload} types={types} id={"imageEditor"}/>

            {/*<Tooltip title={inputTools.imageEditor.label}>*/}
            {/*    <IconButton color="primary" aria-label={inputTools.imageEditor.label} component="label">*/}
            {/*        <input hidden type="file" onChange={onFileUpload} />*/}
            {/*        {isMobile ? inputTools.imageEditor.iconMobile() : inputTools.imageEditor.icon()}*/}
            {/*    </IconButton>*/}
            {/*</Tooltip>*/}
        </Stack>
    );
}